import { ActionTypes, ReduxAction } from './types';
import { AdresseService } from '../../api';
import { Dispatch } from 'redux';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';
import httpSearchQueue from '../../config/HttpSearchQueue';

export const getAdressenByParam =
  (
    mandantId: number,
    fremdnummer: string,
    name: string,
    lkz: string,
    plz: string,
    ortsname: string,
    strasse: string
  ) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    // if (!fremdnummer && !name && !lkz && !plz && !ortsname && !strasse)
    //   return null;
    //#81844 knallt sonst, wenn mann 2 Leerzeichen hintereinander eingibt
    if (!fremdnummer && name.trim().length == 0) return;
    new AdresseService()
      .searchAdressenByParameter(
        mandantId,
        fremdnummer,
        name,
        lkz,
        plz,
        ortsname,
        strasse
      )
      .then(result => {
        dispatch({
          type: ActionTypes.GET_ADRESSEN,
          payload: result.data,
        });
      });
  };

export const getAdressen =
  (searchParam: string, page?: number, searchLimit?: number) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    httpSearchQueue
      .add(new AdresseService().searchAdressen, [
        searchParam,
        page,
        searchLimit,
      ])
      .then(response => {
        dispatch({
          type: ActionTypes.SET_TOTALSEARCHRESULTS,
          payload: response.headers['total-search-results'],
        });
        dispatch({
          type: ActionTypes.GET_ADRESSEN,
          payload: response.data,
        });
      });
  };

export const getAdresseOfMandant =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AdresseService().getAdresseOfMandant(mandantId).then(response => {
      dispatch({
        type: ActionTypes.GET_ABSENDERADRESSE_BY_MANDANT,
        payload: response.data,
      });
    });
  };

export const clearSuchvorschlaege =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.CLEAR_SUCHVORSCHLAEGE,
      payload: null,
    });
  };

export const deleteAdresse =
  (iD: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AdresseService().deleteAdresse(iD).then(response => {
      dispatch({
        type: ActionTypes.DELETE_ADRESSE,
        payload: response.data,
      });
      dispatch({
        type: ActionTypes.RELOAD_ADRESSMANAGEMENT,
      });
      setNotification(
        'Die Adresse wurde erfolgreich entfernt!',
        [],
        INFO,
        10000
      );
    });
  };
